import { connect } from 'react-redux';
import MessageDetail from './MessageDetail.web';
import { getInboxMessageByID } from '../../selectors/messageSelectors';

const mapStateToProps = (state) => ({
  messages: state.inbox,
  message: (id) => getInboxMessageByID(state, id),
});

export default connect(mapStateToProps)(MessageDetail);
